module.exports = __webpack_public_path__ + "media/0008.b90c71a6.mp3";